<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: "app",
    data() {
        return {
            screenWidth: window.innerWidth,
            screenHeight: window.innerHeight
        };
    },
    mounted() {
        const that = this;
        window.onresize = () => {
            return (() => {
                window.screenHeight = window.innerHeight;
                that.screenHeight = window.screenHeight;
                window.screenWidth = window.innerWidth;
                that.screenWidth = window.screenWidth;
            })();
        };
    },
    watch: {
        screenHeight(val) {
            this.screenHeight = val;
            this.$store.dispatch("AccountSetHeight", this.screenHeight);
            let self = this;
            if (this.screenHeight < 620) {
                self.peen = this.screenHeight;
            } else {
                self.peen = 630;
            }
        }
        // screenWidth(val) {
        //     this.screenWidth = val;
        //     this.$store.dispatch("AccountSetWidth", this.screenWidth);
        //     let self = this;
        //     if (this.screenWidth < 620) {
        //         self.peens = this.screenWidth;
        //     } else {
        //         self.peens = 630;
        //     }
        // }
    },
    created() {
        this.$store.dispatch("AccountSetHeight", this.screenHeight);
        // https://api-mop.chinaums.com/v1/netpay/trade/h5-pay?authorization=OPEN-FORM-PARAM&appId=8a81c1be76676b4d017683459aea001d&timestamp=20230607161905&nonce=0104089501340222&content=%7B%22requestTimestamp%22%3A+%222023-06-07+16%3A19%3A05%22%2C+%22mid%22%3A+%2289831017399AQ4G%22%2C+%22tid%22%3A+%2220176940%22%2C+%22instMid%22%3A+%22H5DEFAULT%22%2C+%22merOrderId%22%3A+%22307R2023060716190512345678901234%22%2C+%22expireTime%22%3A+%222023-05-26+13%3A05%3A48%22%2C+%22totalAmount%22%3A+1%2C+%22notifyUrl%22%3A+%22https%3A%2F%2Fwww.baidu.com%22%2C+%22returnUrl%22%3A+%22https%3A%2F%2Fwww.baidu.com%22%7D&signature=TL4JfxoIQxsXtGUQFCzy%2BPKMmSZS1v88sTEQxZR%2Bzs0%3D
    }
};
</script>

<style type="text/scss" lang="scss">
@import "./styles/base";
html {
    height: 100%;
}
body {
    height: 100%;
    overflow: hidden;
}
#app {
    height: 100%;
}
.el-table tr td {
    height: 30px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    font-size: 12px;
}
.el-table tr th {
    text-align: center !important;
    height: 35px !important;
    color: #000 !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    background-color: #f5f5f5 !important;
}
.el-message-box {
    width: 420px !important;
    min-width: 0px;
}
</style>
